import React from "react";
import { InputItem, Button, SwipeAction } from "antd-mobile";

/*
* list添加删除组件
*
* */
function ListEdit(props) {
  const { initItem, list, setList } = props;

  function addItem(index) {
    let addList = list.slice();
    addList.splice(index + 1, 0, initItem ? initItem : "");
    setList(addList);
  }

  function minusItem(index) {
    let minusList = list.slice();
    minusList.splice(index, 1);
    setList(minusList);
  }
  function changeItem(value, index) {
    let changeList = list.slice();
    changeList.splice(index, 1, value);
    setList(changeList);
  }

  return (
    <div>
      {list && list.length > 0 ?
        list.map((item, index) => {
          return (
            <div key={index} style={{ marginTop: '8px', marginBottom: '8px' }}>
              {props.renderItemAndButtons ? props.renderItemAndButtons(
                item,
                (value) => changeItem(value, index),
                () => addItem(index),
                () => minusItem(index),
                index) :
                <SwipeAction
                  autoClose
                  right={[
                    {
                      text: '下方添加',
                      onPress: () => addItem(index),
                      style: { backgroundColor: '#108EE9', color: 'white', fontWeight: 500 },
                    },
                    {
                      text: '删除',
                      onPress: () => minusItem(index),
                      style: { backgroundColor: 'red', color: 'white', fontWeight: 500 },
                    }
                  ]}
                >
                  {props.renderItem ?
                    props.renderItem(item, (value) => changeItem(value, index), index) :
                    <InputItem
                      value={item}
                      onChange={(e) => changeItem(e.target.value, index)} />
                  }
                </SwipeAction>
              }
            </div>
          )
        }) :
        <Button type="primary" className="u-blue mb-10" size="small" style={{ color: 'white', width: '85px' }} onClick={() => addItem(-1)}>添加通道</Button>
      }
      </div>
  )
}
export default ListEdit